import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';

import theme from '../muiTheme';
import './AlertPanel.css';

const panelStyle = {
  borderRadius: theme.borderRadius,
  marginBottom: "10px",
  padding: "12px",
  color: theme.palette.alternateTextColor,
  display: "flex",
  alignItems: "center"
}

const AlertPanel = (props) => {
  let severityColor;
  switch (props.severity) {
    case 1:
      severityColor = theme.palette.accent1Color
      break;
    case 2:
      severityColor = theme.palette.accent2Color
      break;
    case 3:
      severityColor = theme.palette.primary2Color
      break;
    case 4:
      severityColor = theme.palette.secondaryTextColor
      break;
    case 5:
      severityColor = theme.palette.primary1Color
      break;
    default:
      severityColor = theme.palette.primary1Color
  }

  let actionBtn;
  if (props.alertHasAction) {
    actionBtn = (
      <RaisedButton
        label={props.actionLabel}
        onClick={props.onActionClicked}
        disabled={props.disabled} />
    )
  }
  return (
    <div style={{...panelStyle, background: severityColor}}>
      <div className="alert-content">
        {props.children}
      </div>
      <div className="alert-actions">
        {actionBtn}
      </div>
    </div>
  );
}

export default AlertPanel;
